module.exports = __webpack_public_path__ + "img/Alluraa-Influencer-Tile-041.0db2203c.png";